// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yellow-border-bottom[data-v-84a3865c]{border-bottom:3px solid #ffcd4c}.green-border-bottom[data-v-84a3865c]{border-bottom:3px solid #72c332}.green-border-bottom.active[data-v-84a3865c]{background-color:#72c332!important}.red-border-bottom[data-v-84a3865c]{border-bottom:3px solid #ff6767}.red-border-bottom.active[data-v-84a3865c]{background-color:#ff6767!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
